module.exports = __webpack_public_path__ + "img/ta4.d652ec95.png";